import { Component, Inject } from '@angular/core';
import { Observable } from 'rxjs';

import type { DoodOpenCheck } from '@core/models/check.model';
import {
  CHECK_DETAILS_BLOCK_DATA_SOURCE,
  CheckDetailsBlockDataSource,
  CheckDetailsBlockViewModel,
} from './check-details-block-view-model';
import { provideCheckDetailsBlockDataSource } from './check-details-block-data-source.providers';

@Component({
  selector: 'app-check-details-block',
  templateUrl: './check-details-block.component.html',
  standalone: false,
  providers: [...provideCheckDetailsBlockDataSource()],
})
export class CheckDetailsBlockComponent {
  protected readonly checkDetailsVm$: Observable<CheckDetailsBlockViewModel>;
  protected readonly loadingCheck: DoodOpenCheck = {
    id: '',
    closed_at: '',
    opened_at: '',
    items: [],
    transactions: [],
    shop: {
      id: '',
      name: '',
      current_user_roles: [],
    },
    marketplace: {
      id: '',
      name: '',
      current_user_roles: [],
    },
    onsite_location: {
      id: '',
      name: '',
    },
    final_price: 0,
    outstanding_amount: 0,
    available_payment_methods: [],
    currency: '',
  };

  constructor(
    @Inject(CHECK_DETAILS_BLOCK_DATA_SOURCE)
    blockDataSource: CheckDetailsBlockDataSource,
  ) {
    this.checkDetailsVm$ = blockDataSource.vm$;
  }
}
